{
  "nav": {
    "home": "Start",
    "tutorials": "Tutorials",
    "barcodes": "Barcodes",
    "contact": "Kontakt",
    "logout": "Abmelden",
    "logoAlt": "DinLabel",
    "download": "Herunterladen",
    "downloadDemo": "Demo herunterladen",
    "buy": "Kaufen",
    "login": "Anmelden",
    "myAccount": "Mein Konto",
    "language": "Sprache",
    "distributorPortal": "Händlerportal"
  },
  "language": {
    "title": "Sprache",
    "description": "Wählen Sie die Sprache der Anwendung. Standardmäßig wird die Browsersprache verwendet.",
    "browser": "Browsersprache verwenden",
    "english": "Englisch",
    "spanish": "Spanisch",
    "german": "Deutsch",
    "french": "Französisch"
  },
  "offline": {
    "title": "Offline",
    "message": "Die Anwendung kann keine Verbindung zum Server herstellen :( !!"
  },
  "dialogs": {
    "apiError": "API-Fehler",
    "confirmYes": "Ja",
    "cancel": "Abbrechen",
    "send": "Senden"
  },
  "portal": {
    "pageTitle": "Händlerportal",
    "actions": "Aktionen",
    "authorized": "Autorisiert",
    "pending": "Genehmigung ausstehend",
    "buyLicenses": "Lizenzen kaufen",
    "pendingApproval": "Ihr Händlerantrag wurde noch nicht genehmigt – bei Fragen können Sie {{email}} kontaktieren. Dieser Vorgang sollte nicht länger als 2 Werktage dauern.",
    "distributorInfo": "Informationen für Händler",
    "loading": "Händlerinformationen werden geladen…",
    "loadError": "Händlerinformationen konnten nicht geladen werden."
  },
  "licenses": {
    "noneAvailable": "Sie haben derzeit keine Lizenzen zum Senden verfügbar.",
    "statAvailable": "Zum Senden verfügbar",
    "statBought": "Gekauft",
    "statSent": "Gesendet",
    "sentHistory": "Gesendete Lizenzen",
    "activatedYes": "Aktiviert",
    "buyTitle": "Händlerportal – Lizenzen kaufen",
    "buyLoading": "Wird geladen…",
    "buyLoadError": "Händlerinformationen konnten nicht geladen werden.",
    "buyIntro": "Geben Sie an, wie viele Lizenzen Sie kaufen möchten – der Händlerpreis beträgt {{price}} Pesos. Händler können DinLabel zu einem angemessenen Preis verkaufen; unser empfohlener Preis beträgt {{recommended}} Pesos.",
    "licenseCountLabel": "Anzahl der Lizenzen",
    "costSummary": "Die Kosten für {{count}} Lizenzen betragen {{cost}} Pesos + Steuern.",
    "buyButton": "{{count}} Lizenzen kaufen",
    "sendTitle": "Lizenz senden",
    "resendConfirm": "Möchten Sie die Lizenz erneut an {{email}} senden?",
    "sendPrompt": "Geben Sie die E-Mail-Adresse ein, an die gesendet werden soll",
    "emailPlaceholder": "email@beispiel.com",
    "errorTitle": "Fehler!",
    "sendError": "Beim Senden der Lizenz ist ein Fehler aufgetreten {{error}}",
    "resentTitle": "Lizenz erneut gesendet!",
    "resentMessage": "Die Lizenz wurde erneut an {{email}} mit Kopie an {{cc}} gesendet",
    "sentTitle": "Lizenz gesendet!",
    "sentMessage": "Die Lizenz wurde an {{email}} mit Kopie an {{cc}} gesendet",
    "sendToEmail": "Lizenz per E-Mail senden...",
    "recipient": "Lizenzempfänger",
    "date": "Datum",
    "sent": "Gesendet",
    "activated": "Aktiviert",
    "notActivated": "Noch nicht aktiviert",
    "resend": "Lizenz erneut senden"
  },
  "register": {
    "title": "Händler werden",
    "intro": "Um auf das DinLabel-Händlerportal zuzugreifen, müssen Sie sich zuerst registrieren:",
    "company": "Firma",
    "companyPlaceholder": "Firmenname",
    "phone": "Telefon",
    "phonePlaceholder": "Telefon",
    "phoneDescription": "Achten Sie darauf, die Ländervorwahl anzugeben, z. B. +49 30...",
    "street": "Straße",
    "street1Placeholder": "Straße 1",
    "street2Placeholder": "Straße 2",
    "number": "Nummer",
    "city": "Stadt",
    "state": "Bundesland",
    "country": "Land",
    "zip": "Postleitzahl",
    "rfc": "Steuer-ID",
    "nextSteps": "Sie erhalten eine E-Mail mit den nächsten Schritten",
    "submit": "Absenden"
  },
  "faq": {
    "qGoogleAccount": "Benötige ich ein Google-Konto, um DINLabel-Händler zu werden?",
    "aGoogleAccount": "Ja, Sie benötigen ein Google-Konto. Wenn Sie bereits eines haben, können Sie sich damit im Händlerportal anmelden.",
    "qRequirements": "Was brauche ich, um DINLabel-Händler zu werden?",
    "aRequirementsBefore": "Registrieren Sie sich als Händler im",
    "aRequirementsLink": "Händlerportal",
    "aRequirementsAfter": "und warten Sie auf die Bestätigungs-E-Mail, die Sie als DINLabel-Händler autorisiert.",
    "qAnyoneCanSell": "Kann jede Person oder jedes Unternehmen DINLabel verkaufen?",
    "aAnyoneCanSell": "Ja, Sie müssen sich nur im DINLabel-Händlerportal registrieren und die Bestätigungs-E-Mail erhalten.",
    "qHowManyDistributors": "Wie viele Händler kann es bei DINLabel geben?",
    "aHowManyDistributors": "Es gibt keine Begrenzung.",
    "qDistributorCost": "Was kostet eine DINLabel-Lizenz für einen Händler?",
    "aDistributorCost": "112 USD zuzüglich Steuern pro Lizenz.",
    "qRecommendedPrice": "Was ist der empfohlene Verkaufspreis vom Händler an seine Kunden für eine DINLabel-Lizenz?",
    "aRecommendedPrice": "Der Händler legt den Preis fest; es gibt keinen festen Preis. Wir empfehlen einen Verkaufspreis von 160 USD zuzüglich Steuern. Direktkunden im DinLabel-Portal abonnieren für 15 USD pro Monat zuzüglich Steuern.",
    "qWhereToBuy": "Wo kann ein Endnutzer DinLabel erhalten?",
    "aWhereToBuyBefore": "Neue Kunden abonnieren monatlich auf der Kaufseite oder erhalten eine Lizenz von einem Händler. Bestehende Einmalkäufer behalten lebenslangen Zugriff. Kaufen oder abonnieren im Portal",
    "qHowBuyAsDistributor": "Als Händler, wie kaufe ich DINLabel-Lizenzen?",
    "aHowBuyAsDistributorBefore": "Über das Händlerportal im Bereich Lizenzen kaufen. Siehe das Tutorial",
    "aHowBuyAsDistributorLink": "wie man Lizenzen kauft.",
    "qMinimumLicenses": "Als Händler, wie viele Lizenzen muss ich mindestens kaufen, um sie später an meine Kunden zu verkaufen?",
    "aMinimumLicenses": "Es gibt kein Minimum; Sie können ab 1 Lizenz kaufen.",
    "qHowDeliver": "Als Händler, wie liefere ich eine DINLabel-Lizenz an meinen Kunden?",
    "aHowDeliverBefore": "Über das Händlerportal im Bereich",
    "aHowDeliverSendLink": "Lizenzen senden",
    "aHowDeliverMiddle": "; siehe das",
    "aHowDeliverTutorialLink": "Tutorial zum Senden von Lizenzen.",
    "qHowLongPurchase": "Wie lange dauert es, als Händler eine Lizenz zu kaufen und an den Kunden zu liefern?",
    "aHowLongPurchase": "Wenn Sie bereits als Händler registriert sind, können Kauf und Lizenzlieferung in wenigen Minuten erfolgen.",
    "qHowLongToSell": "Als Händler, wie lange habe ich Zeit, die im Portal gekauften Lizenzen zu verkaufen?",
    "aHowLongToSell": "Händlerlizenzen verfallen nicht. Beim Kauf werden sie Ihrem Lizenzbestand hinzugefügt und können jederzeit verwendet werden.",
    "qHowManyAvailable": "Wie kann ich als Händler sehen, wie viele Lizenzen ich habe?",
    "aHowManyAvailableBefore": "Wenn Sie das DINLabel-",
    "aHowManyAvailableLink": "Händlerportal",
    "aHowManyAvailableAfter": " öffnen, zeigt der erste Bildschirm Ihren Bestand an zum Senden verfügbaren Lizenzen.",
    "qSoldLicenses": "Wie kann ich sehen, welche Lizenzen ich verkauft habe und an wen?",
    "aSoldLicensesBefore": "Über das DINLabel-Händlerportal unter",
    "aSoldLicensesLink": "Details anzeigen",
    "qTryBefore": "Kann ich DINLabel ausprobieren, bevor ich Händler werde?",
    "aTryBeforeBefore": "Ja, Sie können eine Demo unter",
    "aTryBeforeAfter": "herunterladen und ausprobieren.",
    "qMainFaq": "Gibt es FAQs (häufig gestellte Fragen) im DINLabel-Portal?",
    "aMainFaqBefore": "Unter",
    "aMainFaqAfter": "finden Sie die häufigsten Fragen zur Nutzung des DINLabel-Systems.",
    "qTutorials": "Gibt es Tutorials zur Nutzung von DINLabel?",
    "aTutorialsBefore": "Unter",
    "aTutorialsAfter": "finden Sie alle benötigten Tutorials zur Nutzung von DINLabel.",
    "qSupport": "Habe ich als Händler technischen Support?",
    "aSupport": "Per E-Mail; siehe das Ende dieser FAQ.",
    "qOtherQuestion": "Ich habe eine Frage, die nicht auf der Liste steht. Was kann ich tun?",
    "aOtherQuestionBefore": "Wir helfen Ihnen gerne. Gehen Sie zu",
    "aOtherQuestionLink": "Kontakt",
    "aOtherQuestionAfter": ", senden Sie Ihre Fragen, und wir antworten Ihnen gerne."
  },
  "tutorials": {
    "title": "Tutorials",
    "alsoSeeFaqBefore": "Sie können auch die",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutorial: So senden Sie eine Lizenz aus dem Händlerportal",
    "iframeTitle": "Tutorial Lizenz senden"
  },
  "home": {
    "welcome": "Willkommen, {{email}}",
    "error": "Fehler"
  },
  "userLicenses": {
    "hasLicense": "Sie haben bereits vollen Zugriff auf DinLabel.",
    "hasSubscription": "Ihr DinLabel-Abonnement ist aktiv.",
    "manageBilling": "Abrechnung verwalten",
    "noLicense": "Sie haben kein aktives DinLabel-Abonnement",
    "buyHere": "Hier abonnieren"
  },
  "signin": {
    "title": "Anmelden",
    "intro": "Melden Sie sich mit Google oder mit E-Mail und Passwort an.",
    "withGoogle": "Mit Google anmelden",
    "orEmail": "oder",
    "email": "E-Mail",
    "password": "Passwort",
    "withEmail": "Mit E-Mail anmelden",
    "createAccount": "Konto erstellen",
    "forgotPassword": "Passwort vergessen?",
    "emailPasswordError": "Anmeldung fehlgeschlagen. Prüfen Sie E-Mail und Passwort.",
    "agreePrefix": "Indem Sie fortfahren, stimmen Sie unserer",
    "privacyLink": "Datenschutzerklärung und den Nutzungsbedingungen",
    "alreadySignedIn": "Sie sind bereits angemeldet",
    "signedInAs": "Angemeldet als {{email}}",
    "continue": "Weiter",
    "debugSignInUrl": "Anmelde-URL"
  },
  "registerAccount": {
    "title": "Konto erstellen",
    "intro": "Registrieren Sie sich mit E-Mail und Passwort.",
    "email": "E-Mail",
    "password": "Passwort",
    "passwordHint": "Mindestens 8 Zeichen",
    "submit": "Konto erstellen",
    "haveAccount": "Haben Sie bereits ein Konto?",
    "signIn": "Anmelden",
    "error": "Konto konnte nicht erstellt werden.",
    "googleExists": "Diese E-Mail ist bereits mit Google registriert. Melden Sie sich mit Google an und fügen Sie danach unter Mein Konto ein Passwort hinzu."
  },
  "forgotPassword": {
    "title": "Passwort vergessen",
    "intro": "Geben Sie Ihre E-Mail ein. Wenn ein Konto existiert, senden wir einen Reset-Link.",
    "email": "E-Mail",
    "submit": "Reset-Link senden",
    "sent": "Wenn ein Konto mit dieser E-Mail existiert, wurde ein Reset-Link gesendet.",
    "backToSignIn": "Zurück zur Anmeldung",
    "error": "Reset-E-Mail konnte nicht gesendet werden."
  },
  "resetPassword": {
    "title": "Passwort zurücksetzen",
    "password": "Neues Passwort",
    "passwordHint": "Mindestens 8 Zeichen",
    "submit": "Passwort aktualisieren",
    "success": "Ihr Passwort wurde aktualisiert.",
    "signIn": "Anmelden",
    "backToSignIn": "Zurück zur Anmeldung",
    "invalidLink": "Dieser Reset-Link ist ungültig oder unvollständig.",
    "error": "Passwort konnte nicht zurückgesetzt werden."
  },
  "applogin": {
    "title": "In DinLabel fortfahren",
    "intro": "Fahren Sie fort, um die Anmeldung in der Desktop-App abzuschließen.",
    "signedInAs": "Sie sind angemeldet als {{email}}.",
    "continue": "Weiter",
    "switchAccount": "Anderes Konto verwenden",
    "redirecting": "Weiterleitung zur Anmeldung…",
    "invalidTitle": "Ungültiger Anmeldelink",
    "invalidBody": "Diese Seite wird von der DinLabel-Desktop-App geöffnet. Bitte starten Sie die Anmeldung in der Anwendung."
  },
  "marketing": {
    "headline": "Professionelle Software für Etikettenverwaltung und -druck",
    "slogan": "Konfigurieren und drucken Sie einfach auf Thermo- (Zebra und mehr), Laser- und Tintenstrahldruckern. Fügen Sie Texte, Barcodes, variable Daten und fortlaufende Nummerierung auf Stoff-, Karton- oder Klebeetiketten hinzu.",
    "featureNumbers": "Fortlaufende Nummerierung & Zähler",
    "featureImages": "Scharfe Logos & Bilder",
    "featureVariable": "Variable Daten ohne Aufwand",
    "featureQr": "Interaktive QR-Codes",
    "featureText": "Klarer, lesbarer Text",
    "featureBarcode": "Professionelle Barcodes",
    "featureDemo": {
      "productName": "Produktname",
      "oliveOil": "Olivenöl",
      "oliveOilDesc": "Beschreibung des Olivenöls",
      "fontsNote": "Klare, feine, lesbare Schriften",
      "sequence": "Sequenz {{n}}",
      "client": "KUNDE:",
      "name": "Name",
      "city": "STADT:",
      "companyLogo": "Firmenlogo"
    },
    "featuresTitle": "Alles, was Sie auf einem Etikett brauchen",
    "featuresSubtitle": "Erstellen Sie professionelle Etiketten mit den Werkzeugen, auf die Druckereien und Lagerhäuser täglich setzen.",
    "seeBarcodeTypes": "Unterstützte Barcode-Typen ansehen",
    "printersTitle": "Kompatibel mit jedem Drucker",
    "printersSubtitle": "DinLabel verbindet sich direkt mit den Druckern, die Sie bereits in Ihrem Betrieb nutzen — über die Standard-Windows-Treiber.",
    "printersTypesTitle": "Druckertypen und Medien:",
    "printersThermalLabel": "Thermo und Thermotransfer:",
    "printersThermalBody": "Ideal für selbstklebende Rollenetiketten, Tyvek, Nylon, Karton usw.",
    "printersLaserLabel": "Laser und Tintenstrahl (Inkjet):",
    "printersLaserBody": "Ideal für selbstklebende Bogenlayouts, Karton oder Stoff.",
    "whyTitle": "Warum DinLabel?",
    "whyCompatLabel": "Volle Kompatibilität:",
    "whyCompatBody": "Drucken Sie auf jedem Drucker (Thermo, Laser und Tintenstrahl) auf Rollen oder Bögen.",
    "whyCostLabel": "Keine aufgeblähten Kosten:",
    "whyCostBody": "Alle professionellen Funktionen, ohne teure Enterprise-Lizenzen zu zahlen.",
    "whySupportLabel": "Echter technischer Support:",
    "whySupportBody": "Wir helfen Ihnen Schritt für Schritt — vom Download und der Installation bis zum Druck Ihrer Etiketten.",
    "tryTitle": "Testen Sie DinLabel noch heute kostenlos",
    "trySubtitle": "Laden Sie die kostenlose Demo herunter, verbinden Sie den Drucker, den Sie haben (Thermo, Laser oder Tintenstrahl), und prüfen Sie in Minuten, wie Ihre Etiketten gedruckt werden.",
    "needHelp": "Brauchen Sie Hilfe?",
    "customerService": "Kundenservice",
    "customerServiceText": "Kontaktieren Sie uns per E-Mail – wir helfen Ihnen gerne.",
    "tutorialsText": "Schritt-für-Schritt-Video-Tutorials für jede Funktion."
  },
  "barcodes": {
    "title": "Barcode-Typen in DinLabel",
    "intro": "DinLabel druckt die Barcode-Typen, die auf Einzelhandels-, Versand- und Industrieetiketten am häufigsten vorkommen. Die folgenden Typen erscheinen zuerst, wenn Sie einen Barcode hinzufügen. Wählen Sie im Editor Mehr anzeigen, um jeden weiteren unterstützten Typ zu verwenden.",
    "commonTitle": "Die gängigsten Barcode-Typen",
    "commonIntro": "Diese Typen empfehlen wir für die meisten Etiketten. DinLabel unterstützt sie alle direkt.",
    "fullTitle": "Alle unterstützten Barcode-Typen",
    "fullIntro": "Der Barcode-Editor zeigt diese Namen, wenn Sie Mehr anzeigen wählen. Verwenden Sie in DinLabel denselben Namen wie hier.",
    "fullCount": "DinLabel unterstützt {{count}} Barcode-Typen.",
    "ctaInstall": "DinLabel herunterladen",
    "ctaTutorials": "Barcode-Tutorials ansehen",
    "common": {
      "UpcA": {
        "name": "UPC-A",
        "description": "Der 12-stellige Barcode auf den meisten Produkten in Nordamerika."
      },
      "UpcE": {
        "name": "UPC-E",
        "description": "Ein kompakter 6-stelliger UPC für kleine Verpackungen, die kein UPC-A fassen."
      },
      "Ean13": {
        "name": "EAN-13",
        "description": "Der 13-stellige Einzelhandelsbarcode, der weltweit verwendet wird, auch in Europa und Lateinamerika."
      },
      "Ean8": {
        "name": "EAN-8",
        "description": "Ein kürzerer EAN für kleine Produkte, die kein EAN-13 fassen."
      },
      "Code128": {
        "name": "Code 128",
        "description": "Ein hochdichter linearer Barcode für Buchstaben, Zahlen und Symbole. Üblich in Versand und Lager."
      },
      "GS1128": {
        "name": "GS1-128",
        "description": "Code 128 mit GS1-Anwendungskennungen für Logistik, GTIN, Charge und Datum."
      },
      "Code39": {
        "name": "Code 39",
        "description": "Ein weit verbreiteter Industriebarcode für Buchstaben, Zahlen und einige Symbole."
      },
      "Interleaved2of5": {
        "name": "Interleaved 2 of 5",
        "description": "Ein kompakter numerischer Barcode für Lager, Distribution und Industrieetiketten."
      },
      "Itf14": {
        "name": "ITF-14",
        "description": "Ein 14-stelliger Barcode für Versandkartons und Umverpackungen (GTIN-14)."
      },
      "QRCode": {
        "name": "QR-Code",
        "description": "Ein 2D-Code für URLs, Text und mehr. Einfach mit dem Handy zu scannen."
      },
      "DataMatrix": {
        "name": "Data Matrix",
        "description": "Ein kompakter 2D-Code für Elektronik, Gesundheitswesen und kleine Bauteile."
      },
      "Pdf417": {
        "name": "PDF417",
        "description": "Ein gestapelter 2D-Barcode mit mehr Daten als typische 1D-Codes, z. B. auf Ausweisen, Versandetiketten und Tickets."
      }
    }
  },
  "footer": {
    "tagline": "Professionelles Etikettendesign für Thermodrucker — Zebra und mehr.",
    "privacy": "Datenschutz & Bedingungen",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Herunterladen",
    "intro": "Installieren Sie DinLabel unter Windows und beginnen Sie in Minuten mit dem Design von Etiketten für Thermodrucker — einschließlich Zebra und anderer Windows-Etikettendrucker.",
    "windowsNote": "Windows-Installer (.exe). Funktioniert unter Windows 7 und neuer.",
    "requirements": "Systemanforderungen",
    "reqWindows": "Jede Windows-Version ab Windows 7",
    "reqInternet": "Internetzugang",
    "reqRam": "1 GB RAM",
    "reqDisk": "10 GB Festplattenspeicher",
    "freeTag": "Demo-Version",
    "freeText": "Die Demo-Version enthält ein Wasserzeichen auf gedruckten Etiketten.",
    "paidTitle": "Vollversion",
    "paidText": "Keine Wasserzeichen — bereit für den Produktionsdruck.",
    "buyApp": "Anwendung kaufen",
    "orDistributor": "Lieber über einen Partner kaufen?",
    "distributorsLink": "Händler anzeigen",
    "emailModalTitle": "Demo herunterladen",
    "emailModalIntro": "Geben Sie Ihre E-Mail-Adresse ein, um die DinLabel-Demo herunterzuladen.",
    "emailLabel": "E-Mail",
    "emailSubmit": "Herunterladen",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "emailSubmitError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "purchasedIntro": "Laden Sie DinLabel herunter und installieren Sie es, um Ihre Vollversion zu nutzen.",
    "signInTitle": "So melden Sie sich an",
    "signInStep1": "Laden Sie DinLabel mit der Schaltfläche oben herunter und installieren Sie es.",
    "signInStep2": "Öffnen Sie DinLabel.",
    "signInStep3": "Wählen Sie Anmelden / Registrieren im Menü.",
    "signInStep4": "Melden Sie sich mit demselben Google-Konto an, mit dem Sie gekauft haben. Nach der Anmeldung nutzen Sie die Vollversion von DinLabel."
  },
  "fullTutorials": {
    "title": "Tutorials",
    "intro": "Schritt-für-Schritt-Videos, die Ihnen helfen, DinLabel zu nutzen, zu drucken und optimal einzusetzen.",
    "howToRoll": "So erstellen Sie ein Etikett auf einer Rolle",
    "howToSheet": "So erstellen Sie ein Etikett auf einem Bogen",
    "howTo3Across": "So erstellen Sie 3-bahnige Etiketten",
    "howToText": "So fügen Sie Text hinzu",
    "howToShapes": "So fügen Sie Formen hinzu",
    "howToImages": "So fügen Sie Bilder hinzu",
    "howToBarCodes": "So fügen Sie Barcodes hinzu",
    "howToQR": "So fügen Sie QR-Codes hinzu",
    "howToPrint": "So drucken Sie",
    "howToConsecutive": "So verwenden Sie fortlaufende Nummern",
    "howToDataBase": "So verwenden Sie Datenbanken",
    "howToBuy": "So kaufen Sie DinLabel",
    "alsoDistributor": "Händlerspezifische Tutorials finden Sie im Händlerportal.",
    "distributorLink": "Händlerportal öffnen"
  },
  "privacy": {
    "title": "Datenschutzerklärung und Nutzungsbedingungen",
    "eulaLink": "Endbenutzer-Lizenzvertrag",
    "policyLink": "Datenschutzerklärung",
    "note": "Die Datenschutzerklärung öffnet das lokalisierte statische HTML-Dokument.",
    "loading": "Wird geladen…",
    "eulaLoadError": "Die EULA konnte nicht geladen werden."
  },
  "distributors": {
    "title": "Händler"
  },
  "buyPage": {
    "title": "DinLabel abonnieren",
    "intro": "Schalten Sie die Vollversion mit einem Monatsabonnement frei — ohne Wasserzeichen, bereit für Thermo- und Produktionsdruck auf Zebra und anderen Etikettendruckern.",
    "panelTitle": "Monatsabonnement",
    "errorTitle": "Etwas ist schiefgelaufen",
    "thanks": "Danke für Ihr DinLabel-Abonnement. Sie haben jetzt vollen Zugriff auf die App!",
    "thanksLifetime": "Danke — Sie haben bereits lebenslangen Zugriff auf DinLabel.",
    "checkAccount": "Kontostatus prüfen",
    "goToDownload": "Zur Download-Seite",
    "manageBilling": "Abrechnung verwalten",
    "price": "USD ${{price}}/Monat + Steuern",
    "payWithCard": "Mit Karte abonnieren",
    "payError": "Weiterleitung zu Stripe Checkout fehlgeschlagen.",
    "adminTestMode": "Dies ist ein Admin-Benutzer, daher verwendet der Checkout Testmode-Informationen. Verwenden Sie die Kreditkarte '4242 4242 4242 4242'.",
    "debugToggleBought": "Nur für Admins: Debug: Bought umschalten",
    "toggleBoughtError": "Bought-Status konnte nicht umgeschaltet werden.",
    "orVia": "Andere Option bevorzugen?",
    "downloadDemo": "Eine voll funktionsfähige Demo herunterladen"
  },
  "userInfo": {
    "title": "Mein Konto",
    "detailsTitle": "Kontodaten",
    "quickLinks": "Schnelllinks",
    "userId": "Benutzer-ID",
    "email": "E-Mail-Adresse",
    "emailConfirmed": "E-Mail bestätigt",
    "confirmed": "Bestätigt",
    "notConfirmed": "Nicht bestätigt",
    "resend": "Erneut senden",
    "resentEmail": "Bestätigungs-E-Mail erneut an {{email}} gesendet",
    "resendError": "Bestätigungs-E-Mail konnte nicht erneut gesendet werden.",
    "version": "Anwendungsversion",
    "freeVersion": "Demo-Version",
    "fullVersion": "Vollversion",
    "lifetimeAccess": "Lebenslanger Zugriff",
    "subscription": "Abonnement",
    "subscriptionTitle": "Abonnement",
    "subscriptionStatus": "Status",
    "subscriptionRenews": "Verlängert am",
    "subscriptionEnds": "Zugriff bis",
    "subscriptionCancelScheduled": "Endet zum Periodenende",
    "subscriptionLoading": "Abonnement wird geladen…",
    "subscriptionError": "Abonnementstatus konnte nicht geladen werden.",
    "manageBilling": "Abrechnung verwalten",
    "statusActive": "Aktiv",
    "statusTrialing": "Testphase",
    "statusPastDue": "Zahlungsrückstand",
    "statusCanceled": "Gekündigt",
    "statusUnpaid": "Unbezahlt",
    "statusIncomplete": "Unvollständig",
    "statusIncompleteExpired": "Abgelaufen",
    "statusPaused": "Pausiert",
    "statusUnknown": "{{status}}",
    "buyApp": "Abonnieren",
    "accountType": "Konto",
    "admin": "Admin-Portal",
    "openDistributorPortal": "Händlerportal öffnen",
    "setPasswordTitle": "Passwort hinzufügen",
    "setPasswordIntro": "Fügen Sie ein Passwort hinzu, um sich auch per E-Mail anzumelden. Konto und Lizenz bleiben gleich.",
    "changePasswordTitle": "Passwort ändern",
    "changePasswordIntro": "Aktualisieren Sie das Passwort für die E-Mail-Anmeldung.",
    "confirmEmailBeforePassword": "Bestätigen Sie Ihre E-Mail, bevor Sie ein Passwort hinzufügen.",
    "currentPassword": "Aktuelles Passwort",
    "newPassword": "Neues Passwort",
    "passwordHint": "Mindestens 8 Zeichen",
    "setPasswordExpand": "Passwort hinzufügen",
    "changePasswordExpand": "Passwort ändern",
    "passwordFormCancel": "Abbrechen",
    "setPasswordSubmit": "Passwort speichern",
    "changePasswordSubmit": "Passwort aktualisieren",
    "passwordSet": "Passwort gespeichert. Sie können sich jetzt mit E-Mail und Passwort anmelden.",
    "passwordChanged": "Passwort aktualisiert.",
    "passwordError": "Passwort konnte nicht aktualisiert werden."
  },
  "myLabels": {
    "title": "Meine Etiketten",
    "loading": "Wird geladen…",
    "loadError": "Etiketten konnten nicht geladen werden.",
    "empty": "Sie haben keine gespeicherten Etiketten.",
    "name": "Name",
    "date": "Datum",
    "view": "Anzeigen",
    "download": "Herunterladen",
    "back": "Zurück zu meinen Etiketten"
  },
  "admin": {
    "title": "Admin-Portal",
    "dataLink": "DinLabel Client-Analytics-Dashboard",
    "serverAnalyticsLink": "Server-Analytics-Dashboard",
    "fakeEmailLink": "Fake-E-Mails",
    "loading": "Wird geladen…",
    "loadError": "Admindaten konnten nicht geladen werden.",
    "totalUsers": "Benutzer insgesamt: {{count}}",
    "paidUsers": "Zahlende Benutzer: {{count}}",
    "totalSubscribedUsers": "Abonnenten gesamt: {{count}}",
    "users": "Benutzer",
    "distributors": "Händler",
    "payments": "Händlerzahlungen",
    "demoDownloaders": "Demo-Downloads",
    "authorize": "Autorisieren"
  },
  "fakeEmail": {
    "title": "Fake-E-Mails",
    "description": "Vorschau generierter E-Mail-Vorlagen mit Platzhalterdaten.",
    "distributorSignUp": "Händler-Anmeldung",
    "activationLink": "Aktivierung / E-Mail bestätigen",
    "sendEmailLicense": "Händler sendet Lizenz",
    "congratulationEmail": "Glückwunsch",
    "boughtLicensesMail": "Gekaufte Lizenzen",
    "demoDownloadThankYou": "Demo-Download Danke",
    "subject": "Betreff",
    "body": "Text",
    "loading": "Wird geladen…",
    "loadError": "Diese E-Mail konnte nicht geladen werden.",
    "backAdmin": "Zurück zur Administration",
    "testAddress": "Testadresse",
    "testAddressPlaceholder": "du@beispiel.com",
    "sendTest": "Test senden",
    "sendSuccess": "{{action}} an {{email}} gesendet",
    "sendError": "Test-E-Mail konnte nicht gesendet werden."
  }
}
